<template>
  <div>
    <title-row
      :title="page.title"
      :subtitle="page.subtitle"
      :breadcrumb-items="[

        page.breadcrumbItem,
      ]">
      <template #buttons>
        <title-row-button v-if="hasRight('DEVICE_WRITE')" :to="{ name: 'NewTurnstile' }">
          <v-icon left>mdi-plus</v-icon>
          Új forgóvilla
        </title-row-button>
      </template>
    </title-row>

    <v-expansion-panels class="mb-4 rounded-xl overflow-hidden" :mandatory="!!Object.values(search).find((e) => e !== '')" flat>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="font-weight-medium">
            <v-icon left>mdi-magnify</v-icon>
            Keresés
          </span>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col :cols="12" :sm="4" :md="3">
              <v-text-field
                v-model="search.name"
                @input="searchEventHandler"
                label="Megnevezés"
                clearable
                hide-details
                filled
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Épület"
                v-model="search.building_id"
                @change="buildingChangedEventHandler"
                :items="buildings"
                item-text="name"
                item-value="id"
                hide-details
                clearable
                filled
              />
            </v-col>
            <v-col :cols="12" :sm="4" :md="3">
              <v-autocomplete
                label="Épület szint"
                v-model="search.building_level_id"
                @change="searchEventHandler"
                :items="buildingLevels"
                item-text="name"
                item-value="id"
                hide-details
                clearable
                :placeholder="search.building_id ? 'Összes szint' : 'Épület kötelező'"
                :readonly="!search.building_id"
                filled
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-card class="rounded-xl" flat>
      <v-data-table
        :loading="loading"
        :headers="dataTable.headers"
        :items="dataTable.items"
        :server-items-length="dataTable.itemsLength"
        :options.sync="dataTable.options"
        :footer-props="$config.dataTableFooterProps"
      >
        <template #[`item.k`]="{ item }">{{ item.x_coord }}, {{ item.y_coord }}</template>
        <template #[`item.actions`]="{ item }" class="d-flex justify-content-end" text-end>
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            fab
            small
            dark
            text
            color="primary"
            class="rounded-sm"
            :to="{ name: 'TurnstileEditor', params: { id: item.element_id } }"
            title="Módosítás"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="hasRight('DEVICE_WRITE')"
            fab
            small
            color="primary"
            dark
            text
            class="rounded-sm"
            @click="deleteTurnstile(item.element_id)"
            title="Törlés"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { dataTablePage } from '@/mixins';

export default {
  mixins: [dataTablePage],

  data() {
    return {
      routeName: 'TurnstileList',
      fetchItems: this.fetchTurnstiles,
      dataTable: {
        options: {
          sortBy: ['turnstile_name'],
        },
        headers: [
          { text: 'Megnevezés', value: 'turnstile_name' },
          { text: 'Épület', value: 'building' },
          { text: 'Épület szint', value: 'building_level' },
          { text: 'Kontroller', value: 'controller' },
          { text: 'Koordináta', value: 'k' },
          { text: '', value: 'actions', sortable: false, align: 'end' },
        ],
      },
      search: {
        building_id: 0,
        building_level_id: 0,
        name: '',
      },

      turnstiles: [],
      buildings: [],
      buildingLevels: [],
    };
  },

  mounted() {
    this.fetchBuildings();

    if (this.search.building_id) {
      this.fetchBuildingLevels();
    }
  },

  methods: {
    parseSearchQueries() {
      return {
        building_id: Number(this.$route.query.building_id),
        building_level_id: Number(this.$route.query.building_level_id),
        name: this.$route.query.name,
      };
    },

    async deleteTurnstile(item) {
      const confirm = await this.$dialog.confirm({
        type: 'error',
        text: `<b>${item.name}</b> forgóvilla törlésére készül!<br>Folytatja?`,
        title: 'Figyelem',
      });

      if (!confirm) return;

      try {
        const response = await this.$http.get(`turnstile/delete/${item.element_id}`);
        this.fetchItems();
        if (response.status === 'OK') {
          this.$dialog.notify.info('A forgóvilla törölve');
        }
      } catch (e) {
        console.error(e);
      }
    },

    buildingChangedEventHandler() {
      this.search.building_level_id = 0;
      this.fetchBuildingLevels();
      this.searchEventHandler();
    },

    async fetchBuildings() {
      try {
        const response = await this.$http.post('buildings/list');
        this.buildings = response.buildings;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchBuildingLevels() {
      try {
        const response = await this.$http.post('building-levels/list', {
          building_id: this.search.building_id,
        });
        this.buildingLevels = response.building_levels;
      } catch (e) {
        console.error(e);
      }
    },

    async fetchTurnstiles() {
      this.loading = true;
      try {
        const response = await this.$http.post('turnstiles/list', this.options);
        this.dataTable.items = response.turnstiles;
        this.dataTable.itemsLength = response.turnstiles_count;
        this.dataTable.options.page = this.$route.query.page * 1 || 1;
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {
    searchQueries() {
      return {
        building_id: this.search.building_id || '',
        building_level_id: this.search.building_level_id || '',
        name: this.search.name || '',
      };
    },
    page() {
      return {
        title:'Forgóvillák',
        subtitle: this.dataTable.itemsLength === -1 ? 'Betöltés...' : `${this.dataTable.itemsLength} forgóvilla van a rendszerben`,
        breadcrumbItem: {
          text: 'Forgóvillák',
          disabled: true,
        }
      }
    }
  },
};
</script>
